import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { urlAuth, storedValudationData } from '../models/urlAuthParams.model';
import { valuationByHash } from '../models/valuation.model';
import { ApiService } from './api.service';

@Injectable()
export class ValuationService {
    constructor(
        private readonly api: ApiService,
        private readonly ngxService: NgxUiLoaderService,
        private readonly router: Router,
    ) { }

    public syncValuationData(routeParams: any): Promise<valuationByHash> {
        return new Promise((resolve, reject) => {
            // Save params in storage.
            // Data is present, check if we're using other keys this time.
            const params = routeParams as urlAuth;

            if (params.customerHash && params.customerId && params.valuationHash && params.valuationId) {
                const valuationAuth: storedValudationData = JSON.parse(localStorage.getItem('valuation'));
                const customerAuth: storedValudationData = JSON.parse(localStorage.getItem('customer'));

                if (valuationAuth == null) {
                    // No parameters in storage. Save parameters
                    localStorage.setItem('customer', JSON.stringify({ hash: params.customerHash, id: params.customerId }));
                } else {
                    // Parameters are set, check if we need to update them.
                    if (valuationAuth.hash != params.customerHash && valuationAuth.id != params.customerId) {
                        localStorage.setItem('customer', JSON.stringify({ hash: params.customerHash, id: params.customerId }));
                    }
                }

                if (customerAuth == null) {
                    // No parameters in storage. Save parameters
                    localStorage.setItem('valuation', JSON.stringify({ hash: params.valuationHash, id: params.valuationId }));
                } else {
                    // Parameters are set, check if we need to update them.
                    if (customerAuth.hash != params.valuationHash && customerAuth.id != params.valuationId) {
                        localStorage.setItem('valuation', JSON.stringify({ hash: params.valuationHash, id: params.valuationId }));
                    }
                }
            }

            const valuationAuth: storedValudationData = JSON.parse(localStorage.getItem('valuation'));
            if (valuationAuth != null) {
                // Get valuation data.
                if (valuationAuth.id != null && valuationAuth.hash != null) {
                    setTimeout(() => {
                        this.api.getValuationIdByHash(valuationAuth.id, valuationAuth.hash).subscribe(data => {
                            if (data.error == false) {
                                localStorage.setItem('valuationData', JSON.stringify(data.data));
                                resolve(data.data);
                                this.ngxService.stop();
                            } else {
                                this.ngxService.stop();
                                this.router.navigate(['/error', { errorType: 'response-false' }]);
                                reject(data)
                            }
                        }, error => {
                            this.ngxService.stop();
                            this.router.navigate(['/error', { errorType: 'response-error' }]);
                            reject(error)
                        })
                    }, 500);
                } else {
                    this.ngxService.stop();
                    reject('Error! No url params or saved params.');
                    this.router.navigate(['/error', { errorType: 'no-permission' }]);
                }
            } else {
                this.ngxService.stop();
                reject('Error! No url params or saved params.');
                this.router.navigate(['/error', { errorType: 'no-permission' }]);
            }
        })
    }
}
